import { useEffect } from "react";
import { Title, Section, Button } from "@vshp/ui-components";
import programConsultationBg from "../../../public/images/consultation.jpg";
import { isLoggedIn } from "../../actions/global";
import { URL_PROFILE } from "../../config/config";
import Image from "next/image";

const ProgramConsultation = ({ isNoSpaceBottom }) => {
  let loggedIn;

  useEffect(() => {
    loggedIn = isLoggedIn();
  }, []);

  return (
    <section className={`page__block page__block_cover page__block_center page__block_cover_white${isNoSpaceBottom ? " page__block_no_space_bottom" : ""}`}>
      <Image className="page__block-img" src={programConsultationBg} alt="ПОЛУЧИТЕ КОНСУЛЬТАЦИЮ У СПЕЦИАЛИСТА!" placeholder="blur" />
      <div className="page__block-body">
        <Title type="h2" decor={false}>
          ПОЛУЧИТЕ КОНСУЛЬТАЦИЮ У СПЕЦИАЛИСТА!
        </Title>

        <Section.BodySmall>
          <div className="wysiwyg">
            <p
              className="page__block-text"
              dangerouslySetInnerHTML={{
                __html: `Если у&nbsp;вас есть вопросы по&nbsp;обучению, мы&nbsp;с&nbsp;удовольствием проконсультируем вас. Напишите нам и&nbsp;мы&nbsp;подберем вам программу обучения, поможем с&nbsp;переводом из&nbsp;другого учебного заведения и&nbsp;т.д.`,
              }}
            ></p>
          </div>
          {loggedIn ? (
            <Button href={`${URL_PROFILE}/profile`} spaceTop={true} target="_blank" rel="noopener noreferrer">
              Задать вопрос
            </Button>
          ) : (
            <Button href={`${URL_PROFILE}/sign_in`} spaceTop={true} target="_blank" rel="noopener noreferrer">
              Задать вопрос
            </Button>
          )}
        </Section.BodySmall>
      </div>
    </section>
  );
};

export default ProgramConsultation;
